import {createSelector} from 'reselect';

const gsConfigSelector = (state) => (state && state.gsConfig) || {};
const featureFlagsSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig.features || {});
const storeIdSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig.shstoreId);
const currentLocaleSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig.currentLocale);
const defaultWebTLDSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig.defaultWebTLD);

export {gsConfigSelector, featureFlagsSelector, storeIdSelector, currentLocaleSelector, defaultWebTLDSelector};
